let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3DZ25")).then(() => parcelRequire('1UoO4'));